
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/components/DataGrid/virtualization",
      function () {
        return require("private-next-pages/components/DataGrid/virtualization.mdx");
      }
    ]);
  